// @flow
import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  pt, px, ml, mr
} from 'styled-components-spacing';
import ReactPaginate from 'react-paginate';

import theme from '@theme';

const { colors } = theme;

export const StyledPagination = styled.div`
  ${pt(4.5)}
  display: flex;
  align-items: center;
  justify-content: space-around;
  ${breakpoint('desktop')`
    justify-content: center;
  `}
`;

const containerClassName = 'pagination-container';

const chevron = css`
  pointer-events: none;
  color: ${colors.defaultGreen};
  position: absolute;
  font-size: 64px;
  top: -20px;
  ${breakpoint('desktop')`
    font-size: 96px;
    top: -40px;
  `}
`;

export const StyledPaginateWrapper = styled.div`
  & > .${containerClassName} {
    li {
      background-color: ${colors.greyBlue10};
      color: ${colors.darkBlue};
      cursor: pointer;
      display: inline-block;
      overflow: hidden;
      position: relative;

      &.previous {
        background-color: transparent;
        &:before {
          ${mr(1)}
          ${chevron}
          right: 0;
          content: '‹';
        }
        ${breakpoint('desktop')`
          ${mr(3)}
        `}
        a {
          width: 14px;
          ${breakpoint('desktop')`
            width: 26px;
          `}
        }
      }

      &.next {
        background-color: transparent;
        &:after {
          ${ml(1)}
          ${chevron}
          left: 0;
          content: '›';
        }
        ${breakpoint('desktop')`
          ${ml(3)}
        `}
        a {
          width: 14px;
          ${breakpoint('desktop')`
            width: 26px;
          `}
        }
      }

      &.active {
        cursor: default;
        font-weight: 600;
      }

      a {
        ${px(1)}
        outline: none;
        display: flex;
        height: 40px;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        color: ${colors.darkBlue};
        &:active {
          outline: none;
        }
        ${breakpoint('desktop')`
          ${px(2)}
        `}
      }
    }
  }
`;

export const StyledReactPaginate = styled(ReactPaginate).attrs({
  containerClassName
})``;
